(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["school-cricut-calculator-snippet"] && !Shopify.designMode) return;
  try {
    (function () {
  function intValue(form, name, fallback) {
    const field = form.elements[name];
    if (!field) return fallback;
    const value = parseInt(field.value, 10);
    return Number.isFinite(value) ? value : fallback;
  }

  function machineEstimate(students, operator, demand) {
    let recommended = 1;

    if (operator === 'teacher') {
      recommended = 1;
      if (students > 20 && demand === 'heavy') recommended = 2;
    }

    if (operator === 'rotation') {
      if (students <= 10) recommended = 1;
      else if (students <= 20) recommended = demand === 'light' ? 1 : 2;
      else recommended = 2;

      if (students > 20 && demand === 'heavy') recommended = 3;
    }

    if (operator === 'student') {
      if (students <= 5) recommended = 1;
      else if (students <= 10) recommended = 2;
      else if (students <= 15) recommended = 2;
      else if (students <= 20) recommended = 3;
      else recommended = 4;

      if (demand === 'light' && recommended > 1) recommended -= 1;
      if (demand === 'heavy') recommended = Math.min(5, recommended + 1);
    }

    const minimum = recommended > 1 ? recommended - 1 : 1;

    let note = '';

    if (operator === 'teacher') {
      note = 'Because a teacher or staff member handles most cutting, a small number of machines can serve a full classroom when cuts can be batched or completed outside the class period.';
    } else if (operator === 'rotation') {
      note = 'This assumes students rotate through the Cricut station while other students design, prepare materials, weed, or assemble.';
    } else {
      note = 'This provides more machine access because students are expected to load and run their own projects as part of the activity.';
    }

    if (minimum < recommended) {
      note += ' The minimum setup can still work with more waiting, batching, or cutting outside the session.';
    }

    if (demand === 'heavy') {
      note += ' Because many cuts need to be completed during the session, the recommendation includes additional capacity.';
    }

    return { recommended, minimum, note };
  }

  function heatPressEstimate(students, operator, heatUse) {
    if (heatUse === 'none') return 0;

    if (operator === 'teacher') {
      return heatUse === 'regular' && students > 20 ? 2 : 1;
    }

    if (operator === 'rotation') {
      if (heatUse === 'regular' && students > 15) return 2;
      return 1;
    }

    if (operator === 'student') {
      if (students <= 10) return heatUse === 'regular' ? 2 : 1;
      if (students <= 20) return 2;
      return heatUse === 'regular' ? 3 : 2;
    }

    return 1;
  }

  function starterMaterialScale(students) {
    if (students <= 10) return 1;
    if (students <= 20) return 2;
    return 3;
  }

  function initialize(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('.cec-calc__form');
    const results = root.querySelector('[data-results]');
    const error = root.querySelector('[data-error]');

    root.querySelector('[data-calculate]').addEventListener('click', function () {
      error.hidden = true;
      error.textContent = '';

      const students = intValue(form, 'students', 0);

      if (students < 1 || students > 30) {
        error.textContent = 'Enter the number of students in the same class/session, from 1 to 30. For larger programs, calculate each normal session separately.';
        error.hidden = false;
        return;
      }

      const operator = form.elements.operator.value;
      const demand = form.elements.demand.value;
      const materialsFocus = form.elements.materials.value;
      const heatUse = form.elements.heat.value;
      const makesCards = !!form.elements.cards.checked;

      const machine = machineEstimate(students, operator, demand);
      const heatPresses = heatPressEstimate(students, operator, heatUse);
      const scale = starterMaterialScale(students);

      root.querySelector('[data-result-machines]').textContent = machine.recommended;
      root.querySelector('[data-result-minimum]').textContent = machine.minimum;
      root.querySelector('[data-result-machine-note]').textContent = machine.note;

      const working = [];
      const replacements = [];
      const materials = [];
      const notes = [];

      const matsPerMachine = operator === 'teacher' ? 2 : 3;
      const workingMats = machine.recommended * matsPerMachine;

      working.push(
        `<strong>${workingMats} LightGrip mats</strong> (${matsPerMachine} per recommended machine)`
      );

      working.push(
        `<strong>${machine.recommended} basic tool set${machine.recommended === 1 ? '' : 's'}</strong> — roughly one shared set per machine/workstation`
      );

      if (heatPresses > 0) {
        working.push(
          `<strong>${heatPresses} heat press${heatPresses === 1 ? '' : 'es'}</strong> for heat-applied projects`
        );

        notes.push(
          'Heat presses are only needed if you plan to make iron-on/HTV or other heat-applied projects. Pressing is usually faster than cutting, so most classrooms do not need one heat press for every Cricut machine.'
        );
      }

      if (materialsFocus === 'vinyl') {
        replacements.push(
          `<strong>${machine.recommended} spare Fine-Point blade${machine.recommended === 1 ? '' : 's'}</strong>`
        );

        replacements.push(
          `<strong>${machine.recommended} replacement LightGrip mat${machine.recommended === 1 ? '' : 's'}</strong>`
        );

        materials.push(
          `<strong>Adhesive vinyl:</strong> starter assortment totaling about ${scale * 5}–${scale * 8} linear ft across the colors you expect to use`
        );

        if (heatUse !== 'none') {
          materials.push(
            `<strong>Iron-on / HTV:</strong> starter assortment totaling about ${scale * 5}–${scale * 8} linear ft`
          );
        }

        materials.push(
          `<strong>Transfer tape:</strong> about ${scale * 5}–${scale * 8} linear ft`
        );
      }

      if (materialsFocus === 'paper') {
        replacements.push(
          `<strong>${machine.recommended * 2}–${machine.recommended * 3} Fine-Point blades</strong> for a paper-heavy starter reserve`
        );

        replacements.push(
          `<strong>${machine.recommended * 2} replacement LightGrip mats</strong>`
        );

        materials.push(
          `<strong>Cardstock / paper:</strong> about ${scale * 50}–${scale * 75} sheets in a useful mix of colors`
        );

        if (heatUse !== 'none') {
          materials.push(
            `<strong>Iron-on / HTV:</strong> starter assortment totaling about ${scale * 5} linear ft for occasional heat-applied projects`
          );
        }
      }

      if (materialsFocus === 'mixed') {
        replacements.push(
          `<strong>${machine.recommended * 2} Fine-Point blades</strong> for a mixed-use starter reserve`
        );

        replacements.push(
          `<strong>${machine.recommended}–${machine.recommended * 2} replacement LightGrip mats</strong>`
        );

        materials.push(
          `<strong>Cardstock / paper:</strong> about ${scale * 50} sheets in a useful mix of colors`
        );

        materials.push(
          `<strong>Adhesive vinyl:</strong> starter assortment totaling about ${scale * 5} linear ft`
        );

        if (heatUse !== 'none') {
          materials.push(
            `<strong>Iron-on / HTV:</strong> starter assortment totaling about ${scale * 5} linear ft`
          );
        }

        materials.push(
          `<strong>Transfer tape:</strong> about ${scale * 5} linear ft`
        );
      }

      if (makesCards) {
        replacements.push(
          `<strong>1–2 Card Mats 2×2</strong> to start`
        );

        notes.push(
          'For larger card projects, our practical planning estimate is about 100 cards per 2×2 Card Mat. Cardstock can also wear blades faster than vinyl, so increase your blade reserve if cardmaking becomes a major activity.'
        );
      }

      notes.unshift(
        'These are starter quantities for a new program, not a full-year supply forecast. After the first few projects, use actual classroom consumption to guide future orders.'
      );

      if (materialsFocus !== 'paper') {
        notes.push(
          'If students will use many colors, divide the total vinyl or HTV quantity among the colors your projects are most likely to use rather than buying the full amount in every color.'
        );
      }

      root.querySelector('[data-result-working]').innerHTML =
        working.map((item) => `<li>${item}</li>`).join('');

      root.querySelector('[data-result-replacements]').innerHTML =
        replacements.map((item) => `<li>${item}</li>`).join('');

      root.querySelector('[data-result-materials]').innerHTML =
        materials.map((item) => `<li>${item}</li>`).join('');

      root.querySelector('[data-result-notes]').innerHTML =
        notes.map((item) => `<p>${item}</p>`).join('');

      results.hidden = false;

      results.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    root.querySelector('[data-reset]').addEventListener('click', function () {
      window.setTimeout(function () {
        results.hidden = true;
        error.hidden = true;
      }, 0);
    });

    root.querySelector('[data-print]').addEventListener('click', function () {
      window.print();
    });
  }

  function initializeAll(scope) {
    (scope || document)
      .querySelectorAll('[data-school-cricut-calculator]')
      .forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
